import Vue from 'vue'
import Antd from 'ant-design-vue'
import { message } from 'ant-design-vue'
import 'ant-design-vue/dist/antd.css'
message.config({
    maxCount: 1,
});
Vue.use(Antd)